import { createAsyncThunk } from "@reduxjs/toolkit";
import { organizationAPI } from "libs/apiClient/Organization";

export const getDocumentList = createAsyncThunk(
	"categorizationSlice/getDocumentList",
	async (
		{
			organizationId,
			type,
			archived,
			objectId,
		}: { organizationId: number; type: string; archived: boolean; objectId?: number },
		{ rejectWithValue },
	) => {
		try {
			// return (
			// 	await $api<any[]>(
			// 		`/organization/${organizationId}/docs/categorization?type=${type}&archived=${archived}${
			// 			objectId ? `&objectId=${objectId}` : ""
			// 		}`,
			// 	)
			// ).data;
			return await organizationAPI
				.docsCategorizationDetail(organizationId, { type: type as any, archived, ...(objectId && { objectId }) })
				.then((r) => r.data);
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const getVersionList = createAsyncThunk(
	"categorizationSlice/getVersionList",
	async ({ docId, type, archived }: { docId: number; type: string; archived: boolean }, { rejectWithValue }) => {
		try {
			// return (await $api<any[]>(`/organization/doc/${docId}/categorization/versions?type=${type}&archived=${archived}`))
			// 	.data;
			return await organizationAPI
				.docCategorizationVersionsDetail(docId, { type: type as any, archived })
				.then((r) => r.data);
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const getObjectListWithDocs = createAsyncThunk(
	"categorizationSlice/getObjectListWithDocs",
	async ({ organizationId }: { organizationId: number }, { rejectWithValue }) => {
		try {
			// return (await $api<any[]>(`/organization/${organizationId}/objects/docs?part=1&count=99999`)).data;
			return await organizationAPI.objectsDocsDetail(organizationId, { count: 99999, part: 1 }).then((r) => r.data);
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const getObjectListWithModels = createAsyncThunk(
	"categorizationSlice/getObjectListWithModels",
	async ({ organizationId }: { organizationId: number }, { rejectWithValue }) => {
		try {
			// return (await $api<any[]>(`/organization/${organizationId}/threat/objects?part=1&count=99999`)).data;
			return await organizationAPI.threatObjectsDetail(organizationId, { count: 99999, part: 1 }).then((r) => r.data);
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);
